import { gql } from "@apollo/client";

export const createProductMutation = gql`
  mutation createProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      id
      name
      code
      price
      inventory
      status
      manufacturer {
        id
        name
      }
      thumbnailUrl
      categories {
        id
        name
      }
      public
      description
    }
  }
`;

export const updateProductMutation = gql`
  mutation updateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      name
      code
      price
      inventory
      status
      manufacturer {
        id
        name
      }
      thumbnailUrl
      categories {
        id
        name
      }
      public
      description
    }
  }
`;

export const deleteProductMutation = gql`
  mutation deleteProduct($input: DeleteProductInput!) {
    deleteProduct(input: $input) {
      id
    }
  }
`;

export const productQuery = gql`
  query product($id: ID!) {
    product(id: $id) {
      id
      name
      code
      price
      inventory
      status
      manufacturer {
        id
        name
      }
      thumbnailUrl
      categories {
        id
        name
      }
      public
      description
    }
  }
`;
